import { LibraryVideo } from "shared/lib/interfaces/LibraryVideo";
import apiAxios from "../../apiAxios";

export async function getParticipantLibraryVideos(): Promise<LibraryVideo[]> {
  return (await apiAxios.get("/library/videos")).data;
}
